import { render, staticRenderFns } from "./TransactionFundraisingGoalTip.vue?vue&type=template&id=daf13cee&scoped=true&"
import script from "./TransactionFundraisingGoalTip.vue?vue&type=script&lang=ts&"
export * from "./TransactionFundraisingGoalTip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf13cee",
  null
  
)

export default component.exports